const selectSelectedRecordDetails = (state) => state.records.selectedRecordDetails;

export default selectSelectedRecordDetails;
